import { render, staticRenderFns } from "./InputLink.vue?vue&type=template&id=2383131d&scoped=true&lang=pug&"
import script from "./InputLink.vue?vue&type=script&lang=ts&"
export * from "./InputLink.vue?vue&type=script&lang=ts&"
import style0 from "./InputLink.vue?vue&type=style&index=0&id=2383131d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383131d",
  null
  
)

export default component.exports